import { NOT_SAVABLE_PREFIXES } from "const";
import { LS_LAST_VISITED } from "const/localStorageKeys";

const LAST_VISITED_TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

export const readLastVisitedWithTTL = (managedServices = [], ttlMs = LAST_VISITED_TTL_MS) => {
    try {
        const raw = localStorage.getItem(LS_LAST_VISITED);
        if (!raw) return null;

        const v = JSON.parse(raw);
        if (!v?.pathname || typeof v?.ts !== "number") return null;

        if (Date.now() - v.ts > ttlMs) return null;

        if (NOT_SAVABLE_PREFIXES.some((p) => v.pathname.startsWith(p))) return null;

        if (managedServices.length > 0 && !managedServices.includes(v.service)) return null;

        return v;
    } catch {
        return null;
    }
};